// used to create uuid's for a11y id attributes.
// from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
var generateUUID = function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16); // eslint-disable-line no-bitwise
  });
  return uuid;
};
export default generateUUID;